import { useState } from 'react';
import logo from '@Assets/trajector-logo-white.png';
import NavlinksLarge from './NavlinksLarge';
import NavlinksMobile from './NavlinksMobile';
import { List } from '@phosphor-icons/react';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleReset = () => {
    localStorage.setItem('tab', '0');
  };
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div
      id="navbar"
      className="flex items-center justify-between bg-primary-700 p-0.5"
    >
      <div className="flex w-full items-center justify-between px-4 py-2 shadow-md">
        <div className="flex items-center gap-2">
          <a href="/home" onClick={handleReset}>
            <img src={logo} className="w-[200px]" alt="logo" />
          </a>
        </div>

        <div className="relative md:hidden">
          <button className="flex" onClick={toggleMenu}>
            <List color="white" weight="bold" size={30} />
          </button>
          {isMenuOpen && <NavlinksMobile closeMenu={closeMenu} />}
        </div>

        <div className="hidden md:flex">
          <NavlinksLarge />
        </div>
      </div>
    </div>
  );
}

export default Navbar;
